import { lazy, Suspense } from "react";
import TopBar from "./components/TopBar/TopBar";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

// Code-splitting: mỗi page được tải riêng (lazy) để giảm bundle JS ban đầu
const Home = lazy(() => import("./pages/homepage/Homepage"));
const Single = lazy(() => import("./pages/single/Single"));
const News = lazy(() => import("./pages/News/News"));
const Community = lazy(() => import("./pages/Community/Community"));
const HotNews = lazy(() => import("./pages/HotNews/HotNews"));
const BlogDetail = lazy(() => import("./pages/BlogDetail/BlogDetail"));
const NotFound = lazy(() => import("./pages/NotFound/NotFound"));
const AccRoute = lazy(() => import("./pages/acc/AccRoute"));

function App() {
  return (
    <Router>
      {/* Phải nằm TRONG Router (dùng hook useLocation) và đặt trước mọi trang
          để effect cuộn chạy ngay khi route đổi. */}
      <ScrollToTop />
      <a href="#main-content" className="skip-link">
        Bỏ qua điều hướng, tới nội dung chính
      </a>
      <TopBar />
      <main id="main-content">
        <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route exact path="/cong-dong">
              <Community />
            </Route>
            <Route exact path="/cong-dong/:blogParam">
              <BlogDetail />
            </Route>
            <Route exact path="/hong-bien">
              <HotNews />
            </Route>
            <Route exact path="/hong-bien/:blogParam">
              <BlogDetail />
            </Route>
            <Route path="/huong-dan">
              <News />
            </Route>
            {/* Đường dẫn chuẩn của trang acc — có từ khoá, được index.
                /post/:postId giữ lại cho link cũ, canonical trỏ về đây. */}
            <Route exact path="/acc/:slug">
              <AccRoute />
            </Route>
            <Route path="/post/:postId">
              <Single />
            </Route>
            <Route path="/blog/:blogParam">
              <BlogDetail />
            </Route>
            <Route path="/404">
              <NotFound />
            </Route>
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </Suspense>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
